<template>
  <div>
    <h1>Create Job</h1>
    <div class="l-bg-white">
      <form @submit.prevent="save" @keydown="clearError($event)" autocomplete="no">
        <div class="row mb-3">
          <div class="col-12">
            <h4>Move info</h4>
          </div>
          <div class="col-3">
            <label>Company</label>
            <select v-model="job.company_id" class="form-control" @change="setCompany">
              <option :value="company.id" v-for="company in companies" :key="company.id">{{ company.name }}</option>
            </select>
            <error-field :errors="errors" field="company_id" />
          </div>
          <div class="col-3">
            <label>Carrier</label>
            <select v-model="job.carrier_id" class="form-control">
              <option :value="carrier.id" v-for="carrier in carriers" :key="carrier.id">{{ carrier.name }}</option>
            </select>
            <error-field :errors="errors" field="company_id" />
          </div>
          <div class="col-3">
            <label>Move size</label>
            <select class="form-control" v-model="job.move_size_id">
              <option v-for="move_size in move_sizes" :value="move_size.id" :key="move_size.id">
                {{ move_size.name }}
              </option>
            </select>
            <error-field :errors="errors" field="move_size_id" />
          </div>
          <div class="col-3">
            <label>Arrival window</label>
            <select class="form-control" v-model="job.arrival_window_id">
              <option v-for="arrival_window in arrival_windows" :value="arrival_window.id"
                      :key="arrival_window.id"
              >
                {{ arrival_window.name }}
              </option>
            </select>
            <error-field :errors="errors" field="arrival_window_id" />
          </div>
          <div class="col-3">
            <label>Source</label>
            <select class="form-control" v-model="job.source_id">
              <option v-for="source in sources" :value="source.id" :key="source.id">
                {{ source.name }}
              </option>
            </select>
            <error-field :errors="errors" field="source" />
          </div>
          <div class="col-3">
            <label>Movers</label>
            <input v-model="job.movers" type="text" class="form-control" />
            <error-field :errors="errors" field="movers" />
          </div>
          <div class="col-3">
            <label>Trucks</label>
            <input v-model="job.trucks" type="text" class="form-control" />
            <error-field :errors="errors" field="trucks" />
          </div>
        </div>


        <div class="row mb-3">
          <div class="col-12">
            <h4>Job price</h4>
          </div>
          <div class="col-3">
            <label>Min hours</label>
            <input v-model="job.minimum_hours" type="text" class="form-control" />
            <error-field :errors="errors" field="minimum_hours" />
          </div>
          <div class="col-3">
            <label>Price per hour</label>
            <input v-model="job.price_per_hour" type="text" class="form-control" />
            <error-field :errors="errors" field="price_per_hour" />
          </div>
          <div class="col-3">
            <label>Deposit</label>
            <input v-model="job.deposit_value" type="text" class="form-control" />
            <error-field :errors="errors" field="deposit_value" />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-3">
            <label>Estimated hours</label>
            <input v-model="job.estimated_hours" type="text" class="form-control" />
            <error-field :errors="errors" field="estimated_hours" />
          </div>
          <div class="col-3">
            <label>Price in $</label>
            <input v-model="job.price" type="text" class="form-control" />
            <error-field :errors="errors" field="price" />
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-12">
            <h4>Contact information</h4>
          </div>
          <div class="col-3">
            <label>Customer name</label>
            <select v-model="job.customer" class="form-control">
              <option :value="customer" v-for="customer in customers" :key="customer.id">
                {{ customer.first_name }} {{ customer.last_name }}
              </option>
            </select>
            <error-field :errors="errors" field="customer_id" />
          </div>
          <div class="col-3">
            <label>Customer email</label>
            <input v-model="job.customer.email" type="text" class="form-control" disabled />
            <error-field :errors="errors" field="email" />
          </div>
          <div class="col-3">
            <label>Customer phone</label>
            <input v-model="job.customer.phone" type="text" class="form-control" disabled />
            <error-field :errors="errors" field="phone" />
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-12">
            <h4>Addresses</h4>
          </div>
          <div class="col-3">
            <label>Pickup date</label>
            <datepicker v-model="job.move_date" name="move_date" placeholder="Select Date" class="form-control"
                        :format="dateFormatter"
            />
            <error-field :errors="errors" field="move_date" />
          </div>
        </div>

        <template v-for="(address, index) in job.addresses">
          <div class="row mb-3" :key="address.id">
            <div class="col-6">
              <label>{{ address.type === 1 ? 'Pickup' : 'Delivery' }} address</label>
              <input v-model="address.full_address" type="text" class="form-control"
                     @input="getAddressData(address.full_address, index)"
                     @keydown.prevent.down="$event.target.nextElementSibling.firstChild.focus()"
              />
              <div class="dropdown-menu show" aria-labelledby="dropdownMenu2"
                   v-if="showDropdown[index] === true && addresses[index]"
              >
                <button class="dropdown-item" type="button" v-for="addressInner in addresses[index]" :key="addressInner.id"
                        @click="setAddress(addressInner, index)"
                        @keydown.prevent.down="$event.target.nextElementSibling.focus()"
                        @keydown.up="$event.target.previousElementSibling.focus()"
                >
                  {{ addressInner.full_address }}
                </button>
              </div>
              <error-field :errors="errors" :field="`addresses.${index}.postal_code`" />
            </div>
            <div class="col-3">
              <label>Floor</label>
              <input v-model="address.floor" type="text" class="form-control" />
            </div>
            <div class="col-3">
              <label>Apartment</label>
              <input v-model="address.apartment" type="text" class="form-control" />
            </div>
          </div>
          <div class="row mb-3" :key="address.id">
            <div class="col-4">
              <p>
                <a href="#" class="link" @click="removeAddress(index)">X Remove address</a>
              </p>
            </div>
          </div>
        </template>

        <p>
          <button class="btn btn-primary" type="button" @click="addPickupAddress">+ Add pickup address</button>
          <button class="btn btn-primary" type="button" @click="addDeliveryAddress">+ Add delivery address</button>
        </p>
        <div class="row mb-3">
          <div class="col">
            <button class="btn btn-primary float-right">Save</button>
            <a class="btn btn-danger float-left"
               @click="remove({carrierId: carrier, truckId: truck.id})"
            >
              Delete
            </a>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import toastr from 'toastr';
import Datepicker from 'vuejs-datepicker';
import _ from 'lodash';
import ErrorField from '../ErrorField';
import Errors from '../../classes/Errors';
import Date from '../../classes/Date';

export default {
  components: {
    ErrorField,
    Datepicker,
  },
  data: () => ({
    job: {
      addresses: [
        {
          full_address: '',
          street_name: '',
          state_id: 0,
          city: '',
          postal_code: '',
          apartment: '',
          type: 1,
        },
      ],
      arrival_window_id: null,
      cluster_user: [],
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      move_date: '',
      move_size_id: null,
      movers: null,
      notes: '',
      route_id: '',
      source_id: null,
      status_id: '',
      trucks: '',
      estimated_hours: null,
      customer: {},
      customer_id: null,
      carrier_id: null,
    },
    move_sizes: [],
    arrival_windows: [],
    companies: [],
    customers: [],
    address: null,
    addresses: [],
    showDropdown: [
      {
        0: false,
      },
    ],
    errors: new Errors(),
  }),
  computed: {
    ...mapState({
      states: state => state.values.states,
      sources: state => state.values.sources,
    }),
  },
  mounted() {
    axios
      .get(`companies`)
      .then(result => {
        this.companies = result.data.data;
      })
      .catch(err => this.errors.record(err.response.data.error));
    axios
      .get(`customers`)
      .then(result => {
        this.customers = result.data.data;
      })
      .then(() => {
        if (this.$route.query.customer_id) {
          const cus = this.customers.filter(
            customer => customer.id === parseInt(this.$route.query.customer_id, 10),
          );
          this.$set(this.job, 'customer', cus[0]);
        }
      })
      .catch(err => this.errors.record(err.response.data.error));
  },
  methods: {
    save() {
      this.job.customer_id = this.job.customer.id;
      axios
        .post(`jobs`, { ...this.job })
        .then(res => {
          toastr.success('Successfully created job');
          this.$router.push(`/jobs/edit/${res.data.data.id}`);
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        });
    },
    clearError(event) {
      this.errors.clear(event.target.name);
    },
    addPickupAddress() {
      this.job.addresses.push({
        street_name: '',
        state: [
          {
            name: '',
          },
        ],
        state_id: 0,
        city: '',
        postal_code: '',
        apartment: '',
        type: 1,
      });
    },
    addDeliveryAddress() {
      this.job.addresses.push({
        street_name: '',
        state: [
          {
            name: '',
          },
        ],
        state_id: 0,
        city: '',
        postal_code: '',
        apartment: '',
        type: 2,
      });
    },
    removeAddress(index) {
      this.errors.clear();
      this.job.addresses.splice(index, 1);
    },
    dateFormatter(date) {
      this.job.move_date = Date.formattedDate(date);
      return this.job.move_date;
    },
    setCompany() {
      this.getMoveSizes();
      this.getArrivalWindows();
    },
    getMoveSizes() {
      axios
        .get(`companies/${this.job.company_id}/move-sizes`)
        .then(result => {
          this.move_sizes = result.data.data;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    getArrivalWindows() {
      axios
        .get(`companies/${this.job.company_id}/arrival-windows`)
        .then(result => {
          this.arrival_windows = result.data.data;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    getAddressData: _.debounce(function call(streetName, index) {
      if (streetName.length < 3) {
        this.$set(this.showDropdown, index, false);
      } else {
        if (typeof this.source !== typeof undefined) {
          this.source.cancel('Operation canceled due to new request.');
        }
        this.source = axios.CancelToken.source();
        this.$set(this.showDropdown, index, true);
        axios
          .get(
            `autocomplete?address=${encodeURIComponent(streetName)}`,
            // cancel token used by axios
            { cancelToken: this.source.token },
          )
          .then(res => {
            this.$set(this.addresses, index, res.data.data);
          })
          .catch(err => {
            if (!axios.isCancel(err)) {
              this.errors.record(err.response.data.error);
            }
          });
      }
    }, 500),
    setAddress(address, index) {
      axios
        .get(
          `geocode?place_id=${encodeURIComponent(address.place_id)}&address=${encodeURIComponent(
            address.full_address,
          )}`,
        )
        .then(res => {
          [address] = res.data.data;
          const addressNew = Object.assign({ type_id: this.job.addresses[index].type_id }, address);
          this.$set(this.job.addresses, index, addressNew);
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        });
      this.showDropdown[index] = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/jobs/JobsCreate.vue